export default __webpack_public_path__ + "c56aa4f497fa13dbe0c4815ee95f8bc9.png";